import { BaseAPI } from './BaseAPI.js'
import { TransferCallLog } from '../types/index.js'

export default class TransferCallLogsApi extends BaseAPI<TransferCallLog> {
  override get resource(): string {
    return '/transferCallLogs'
  }
}
